import React from 'react';
import './Pricing.css';

const Pricing: React.FC = () => {
  const plans = [
    {
      name: 'Try Before Buy',
      price: 'Free',
      period: '',
      features: [
        'Preview all 56+ styles',
        'Watermarked samples',
        'Test with your photos',
        'See quality before purchase'
      ],
      cta: 'Download Free',
      isPrimary: false
    },
    {
      name: 'Weekly Access',
      price: '€8.99',
      period: '/week',
      features: [
        'All current styles unlocked',
        'No watermarks',
        'High-resolution exports',
        '40+ portraits per photo set',
        'Commercial usage rights'
      ],
      cta: 'Start Weekly',
      isPrimary: false
    },
    {
      name: 'Monthly Access',
      price: '€19.99',
      period: '/month',
      features: [
        'Everything in Weekly Access',
        'Save over 50% vs weekly',
        'Priority processing',
        'New styles monthly',
        'Early access to features'
      ],
      cta: 'Subscribe Monthly',
      isPrimary: true,
      badge: 'Best Value'
    }
  ];

  return (
    <section id="pricing" className="pricing-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Choose Your Plan</h2>
          <p className="section-subtitle">
            Start free, upgrade when you love it
          </p>
        </div>

        <div className="pricing-grid">
          {plans.map((plan, index) => (
            <div key={index} className={`pricing-card ${plan.isPrimary ? 'primary' : ''}`}>
              {plan.badge && (
                <span className="plan-badge">{plan.badge}</span>
              )}
              <div className="plan-header">
                <h3 className="plan-name">{plan.name}</h3>
                <div className="plan-price">
                  <span className="price-amount">{plan.price}</span>
                  {plan.period && <span className="price-period">{plan.period}</span>}
                </div>
              </div>
              <ul className="plan-features">
                {plan.features.map((feature, idx) => (
                  <li key={idx} className="feature-item">
                    <svg className="feature-check" width="20" height="20" viewBox="0 0 20 20">
                      <path d="M7 10l2 2 4-4" stroke="currentColor" strokeWidth="2" fill="none"/>
                    </svg>
                    {feature}
                  </li>
                ))}
              </ul>
              <button className={`plan-cta ${plan.isPrimary ? 'cta-primary' : 'cta-secondary'}`}>
                {plan.cta}
              </button>
            </div>
          ))}
        </div>

        <div className="pricing-faq">
          <h3>Frequently Asked Questions</h3>
          <div className="faq-grid">
            <div className="faq-item">
              <h4>Can I try before purchasing?</h4>
              <p>Yes! Preview all styles with watermarked samples before buying.</p>
            </div>
            <div className="faq-item">
              <h4>What's included in Full Access?</h4>
              <p>All current styles, no watermarks, and high-resolution exports.</p>
            </div>
            <div className="faq-item">
              <h4>Can I cancel subscription anytime?</h4>
              <p>Yes, cancel anytime from your app settings. No questions asked.</p>
            </div>
            <div className="faq-item">
              <h4>Do I keep my portraits?</h4>
              <p>Yes! All generated portraits are yours to keep forever.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;